import { loadFont } from "@remotion/fonts";
import { useEffect } from "react";
import { AbsoluteFill, Img, staticFile } from "remotion";

export default function Watermark({ show }: { show?: boolean }) {
  const fontFamily = "raleway";
  useEffect(() => {
    loadFont({
      family: "raleway",
      url: staticFile(`fonts/raleway.ttf`),
      weight: "500",
    }).then();
  }, []);

  if (!show) return null;
  return (
    <AbsoluteFill
      style={{
        zIndex: 1000,
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "flex-end",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingBottom: 10,
          paddingRight: 10,
        }}
      >
        <Img src={staticFile("logo.png")} style={{ width: 60, height: 60 }} />
        <div style={{ display: "flex", flexDirection: "row", alignItems: "baseline", marginTop: 1 }}>
          <span
            style={{
              fontFamily,
              fontWeight: "bold",
              fontSize: 21,
              color: "white",
              letterSpacing: 0.8,
            }}
          >
            mAik
          </span>
          <span style={{ fontSize: 18, color: "white", fontFamily, letterSpacing: 0.8, fontWeight: "normal" }}>
            believe.com
          </span>
        </div>
      </div>
    </AbsoluteFill>
  );
}
